import React from "react";
import ProfilePageTemplate from "../shared/ProfilePageTemplate";
import OrganizationStructure from "../shared/OrganizationStructure";

const ProfilMisiInternasionalContent: React.FC = () => {
  const organizationUnits = [
    {
      name: "Bagian Perdamaian dan Kemanusiaan",
      abbreviation: "Bagdamkeman",
      description:
        "Bagdamkeman bertugas mengelola misi perdamaian dan misi kemanusiaan non konflik dalam wadah organisasi Internasional.",
      subUnits: [
        {
          name: "Subbagian Perencanaan dan Kegiatan (Subbagrengiat)",
          description:
            "Perencanaan dan koordinasi kegiatan pra, selama dan pasca penugasan misi",
        },
        {
          name: "Subbagian Pembekalan dan Latihan (Subbagbeklat)",
          description:
            "Perancangan, koordinasi, pengendalian mutu pembekalan dan pelatihan kemampuan personel Polri",
        },
        {
          name: "Subbagian Monitoring dan Evaluasi Misi (Subbagmonev)",
          description:
            "Pengendalian, monitoring, dan evaluasi penyelenggaraan misi",
        },
        {
          name: "Urusan Administrasi (Urmin)",
          description: "Pengelolaan administrasi bagian",
        },
      ],
    },
    {
      name: "Bagian Pengembangan Kapasitas",
      abbreviation: "Bagkembangtas",
      description:
        "Bagkembangtas bertugas menyelenggarakan dan mengoordinasikan kerja sama pengembangan kapasitas internasional baik di dalam maupun di luar negeri dalam rangka meningkatkan kapasitas sumber daya manusia Polri dan logistik Polri.",
      subUnits: [
        {
          name: "Subbagian Kerja Sama Pendidikan Luar Negeri (Subbagkermadiklugri)",
          description:
            "Penginisiasian, perintisan, perancangan, pemfasilitasian, pengoordinasian dan pelaksanaan kerja sama pendidikan personel Polri di luar negeri",
        },
        {
          name: "Subbagian Kerja Sama Sarana Prasarana (Subbagkermasarpras)",
          description:
            "Penginisiasian, perintisan, perancangan, pemfasilitasian, pengoordinasian dan pelaksanaan kerja sama internasional dalam rangka pengembangan kapasitas logistik Polri",
        },
        {
          name: "Urusan Administrasi (Urmin)",
          description: "Pengelolaan administrasi bagian",
        },
      ],
    },
  ];

  const OverviewContent = () => (
    <div className="p-8">
      <div className="prose prose-lg max-w-none">
        <h2 className="text-2xl font-bold mb-4">
          Biro Misi Internasional (ROMISINTER)
        </h2>

        <div className="space-y-4 text-base-content/70">
          <p className="leading-relaxed">
            1. Romisinter merupakan unsur pelaksana utama yang berada di bawah
            Kadivhubinter Polri;
          </p>

          <p className="leading-relaxed">
            2. Romisinter bertugas mengelola tugas misi internasional yang
            meliputi misi perdamaian, tugas misi kemanusiaan, misi pengembangan
            kapasitas personel dan logistik Polri, dan mengendalikan kegiatan
            pelatihan misi internasional Polri; dan
          </p>

          <div>
            <p className="leading-relaxed mb-2">
              3. Dalam melaksanakan tugas, Romisinter menyelenggarakan fungsi:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-2">
              <li>
                pengelolaan pra, selama, dan pasca misi perdamaian dan
                kemanusiaan non konflik dalam wadah organisasi internasional;
              </li>
              <li>
                pengelolaan dan koordinasi kerja sama pengembangan kapasitas
                internasional baik yang dilaksanakan di luar negeri maupun di
                dalam negeri; dan
              </li>
              <li>
                pengelolaan tempat Pelatihan Misi Internasional sebagai pusat
                pembekalan dan pelatihan pengembangan kapasitas internasional,
                misi perdamaian, misi kemanusiaan, dan penyiapan misi
                internasional lainnya;
              </li>
            </ul>
          </div>

          <p className="leading-relaxed font-medium">
            Dalam melaksanakan tugas dan tanggung jawab, Biro Misi Internasional
            dibantu oleh 2 (dua) bagian utama dan 1 urusan tata usaha.
          </p>
        </div>
      </div>
    </div>
  );

  const FunctionsContent = () => (
    <div className="p-8">
      <div className="space-y-8">
        <div className="bg-base-200 rounded-xl p-6">
          <h3 className="text-xl font-bold text-base-content mb-4">
            Fungsi Bagian Perdamaian dan Kemanusiaan
          </h3>
          <ol className="list-decimal list-inside space-y-3 text-base-content/70">
            <li className="leading-relaxed">
              perencanaan dan koordinasi kegiatan pra, selama dan pasca
              penugasan misi perdamaian dan misi kemanusiaan non-konflik dalam
              wadah organisasi internasional, termasuk perancangan, koordinasi,
              pengendalian mutu pembekalan dan pelatihan kemampuan personel
              Polri;
            </li>
            <li className="leading-relaxed">
              perencanaan dan pengadaan logistik personel maupun logistik
              kontingen yang akan ditugaskan pada misi perdamaian dan misi
              kemanusiaan non-konflik dalam wadah organisasi internasional;
            </li>
            <li className="leading-relaxed">
              pengendalian, monitoring, dan evaluasi penyelenggaraan misi
              perdamaian dan misi kemanusiaan non-konflik dalam wadah organisasi
              internasional baik sebelum, selama dan setelah penugasan;
            </li>
          </ol>
        </div>

        <div className="bg-base-200 rounded-xl p-6">
          <h3 className="text-xl font-bold text-base-content mb-4">
            Fungsi Bagian Pengembangan Kapasitas
          </h3>
          <ol className="list-decimal list-inside space-y-3 text-base-content/70">
            <li className="leading-relaxed">
              penginisiasian, perintisan, perancangan, pemfasilitasian,
              pengoordinasian dan pelaksanaan kerja sama pendidikan personel
              Polri di luar negeri;
            </li>
            <li className="leading-relaxed">
              penginisiasian, perintisan, perancangan, pemfasilitasian,
              pengoordinasian dan pelaksanaan pembekalan dan pelatihan
              internasional di dalam negeri dan di luar negeri;
            </li>
            <li className="leading-relaxed">
              penginisiasian, perintisan, perancangan, pemfasilitasian,
              pengoordinasian dan pelaksanaan kerja sama internasional dalam
              rangka pengembangan kapasitas logistik Polri;
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const tabs = [
    {
      id: "overview",
      label: "Gambaran Umum",
      icon: "📋",
      component: <OverviewContent />,
    },
    {
      id: "structure",
      label: "Struktur Organisasi",
      icon: "🏗️",
      component: (
        <OrganizationStructure
          mainTitle="Struktur Organisasi Biro Misi Internasional"
          mainDescription="Biro Misi Internasional dibantu oleh 2 (dua) bagian utama dan 1 urusan tata usaha dalam melaksanakan tugas dan tanggung jawab."
          units={organizationUnits}
        />
      ),
    },
    {
      id: "functions",
      label: "Tugas & Fungsi",
      icon: "⚙️",
      component: <FunctionsContent />,
    },
  ];

  return (
    <ProfilePageTemplate
      title="Profil Biro Misi Internasional"
      subtitle="ROMISINTER"
      icon="🌍"
      breadcrumbBase="Misi Internasional"
      tabs={tabs}
      footerTitle="Biro Misi Internasional"
      footerDescription="Mengelola misi perdamaian, kemanusiaan, dan pengembangan kapasitas internasional Polri untuk mendukung perdamaian dunia."
      footerStats={[
        { label: "Bagian Utama", value: "2" },
        { label: "Sub Bagian", value: "7" },
        { label: "Fokus Misi", value: "3" },
      ]}
    />
  );
};

export default ProfilMisiInternasionalContent;
